const registry = new Set<string>();

export function registerPersistentStorageKey(key: string): void {
  registry.add(key);
}

export function getRegisteredPersistentStorageKeys(): string[] {
  return Array.from(registry);
}
